<template>
    <Sheet v-loading="loading.global">
        <div style="margin-bottom: 10px;">
            <el-divider>
            <span style="font-size:1.1rem;padding-right: 10px;">
                {{lastDrewMonth ? `${lastDrewMonth.month}月份` : ''}} 夜間場地借用抽籤結果查詢
            </span>
            </el-divider>
            <div v-if="lastDrewMonth">
                <span style="font-size:1.1rem;padding-right: 10px;">選擇場地:</span>
                <el-select v-model="roomId" size="large" @change="changeRoom">
                    <el-option
                            v-for="room in drawableRooms"
                            :key="room.id"
                            :value="room.id"
                            :label="room.name"
                    ></el-option>
                </el-select>
            </div>
        </div>
        <div style="display: flex; flex-direction: column; flex-grow: 1;height: 620px;"
             id="drewResult"
             v-if="lastDrewMonth"
        >
            <calendar-view
                    locale="zh-Tw"
                    :show-date="showDate"
                    class="theme-default"
                    :events="drew"
                    :startingDayOfWeek="1"
                    eventContentHeight="1.5em"
                    v-if="drew.length > 0"
            >
            </calendar-view>
            <div v-else style="text-align: center">
                <h1>抱歉，此場地尚未抽籤</h1>
            </div>
        </div>
        <div v-else style="text-align: center">
            <h1>抱歉，尚未開始抽籤</h1>
        </div>
    </Sheet>
</template>

<script>
    import {CalendarView, CalendarViewHeader, CalendarMathMixin} from 'vue-simple-calendar';
    require('vue-simple-calendar/static/css/default.css');
    import {mapState, mapActions, mapGetters} from 'vuex';
    import moment from 'moment';
    export default {
        name: 'DrawResult',
        data: () => ({
            roomId: ''
        }),
        components: {
            CalendarView,
            CalendarViewHeader,
        },
        computed:{
            ...mapState('setting', {
                rooms: state => state.rooms,
                months: state => state.months,
                ncutRooms: state => state.ncutRooms
            }),
            ...mapState(['loading']),
            ...mapState('booking', ['drew']),
            drawableRooms() {
                const drawableNcutRoomIds = new Set(this.rooms.filter(r => r.drawable)
                    .map(r => r.ncutRoomId));
                return this.ncutRooms.filter(r => drawableNcutRoomIds.has(r.id));
            },
            lastDrewMonth() {
                return [...this.months]
                    .sort((a, b) => parseInt(moment(b.fstDate).year() + '' + (b.month + '').padStart(2, '0'))
                        - parseInt(moment(a.fstDate).year() + '' + (a.month + '').padStart(2, '0')))
                    .find(m => m.drewRoomIds.length > 0);
            },
            showDate(){
                if(this.lastDrewMonth){
                    const {fstDate, month} = this.lastDrewMonth;
                    return new Date(moment(fstDate).year(), month - 1, 1 );
                }
                return new Date();
            }
        },
        methods:{
            ...mapActions('setting', {
                getNcutRooms: 'getNcutRoomsAction',
                getMonths: 'getMonthsAction',
            }),
            ...mapActions('booking', {
                getDrewEvents: 'getDrewEventsAction'
            }),
            async changeRoom(roomId){
                const {month} = this.lastDrewMonth;
                await this.getDrewEvents({roomId, month})
            }
        },
        watch:{
            async drawableRooms(current) {
                if (current && current[0]) {
                    this.roomId = current[0].id;
                    const {roomId} = this;
                    const {month} = this.lastDrewMonth || {month: 0};
                    await this.getDrewEvents({roomId, month})
                }
            }
        },
        async created() {
            await this.getNcutRooms();
        }
    }
</script>

<style>
    #drewResult .cv-event{
        margin-bottom: 3px;
    }
</style>